import { useCallback, useState } from 'react';

import Constants from '../../constants';
import { useLessonLink } from '../../hooks/useLessonLink';

/**
 * Hook to manage the mobile view attribute on a containing element.
 * @param lessonkey Identifier of lesson, used to load links.
 */
const useMobilePreviewLink = (lessonkey: number) => {
  const { links, createLink } = useLessonLink(lessonkey);
  const [previewLink, setPreviewLink] = useState<string>();

  const setMobilePreview = useCallback(
    async (preview: boolean) => {
      if (preview) {
        let linkkey = links?.[0]?.linkkey;
        if (!linkkey) {
          const data = await createLink({ modulekey: lessonkey });
          linkkey = data.linkkey;
        }
        setPreviewLink(
          `${document.location.protocol}//${
            document.location.host
          }${Constants.LinkLessonUrl.replace(':linkkey', linkkey)}?frame`
        );
      } else {
        setPreviewLink(undefined);
      }
    },
    [links]
  );

  return { previewLink, setMobilePreview };
};

const useMobilePreviewExternal = (link: string) => {
  const [previewLink, setPreviewLink] = useState<string>();
  const setMobilePreview = (preview: boolean) => {
    setPreviewLink(preview ? link : undefined);
  };
  return { previewLink, setMobilePreview };
};

const useMobilePreview = (lessonkey: number) => {
  const path = document.location.pathname;
  const match = /^\/e\/link\/lesson\/([0-9a-f-]{36})/.exec(path);
  if (match) {
    return useMobilePreviewExternal(path);
  } else {
    return useMobilePreviewLink(lessonkey);
  }
};

export default useMobilePreview;
